import React from "react";
import PropTypes from "prop-types";

import { OrderObject, CurrentUserObject } from "../Queries/OrderQuery";
import OrderContext from "../OrderContext";
import ShipmentsButton from "./ShipmentsButton";

const Shipments = ({ order, currentUser, awaitingCallPending = false, uiActive }) => (
  <OrderContext.Consumer>
    {({ isLineEditing }) =>
      isLineEditing ||
      (!order.uiState.allowProcessShipments && !order.uiState.allowResendShipments) ||
      !uiActive ? (
        <a className={"button button--disabled"}>Shipments</a>
      ) : (
        <ShipmentsButton
          order={order}
          currentUser={currentUser}
          awaitingCallPending={awaitingCallPending}
        />
      )
    }
  </OrderContext.Consumer>
);

Shipments.propTypes = {
  order: OrderObject,
  currentUser: CurrentUserObject.isRequired,
  awaitingCallPending: PropTypes.bool,
  uiActive: PropTypes.bool.isRequired
};

export default Shipments;
